// extracted by mini-css-extract-plugin
module.exports = {"payslipExtras":"PayslipDetailsTab_payslipExtras__1HMyz","extraName":"PayslipDetailsTab_extraName__2mo5M","extraValue":"PayslipDetailsTab_extraValue__2zlKT"};